import React, { useEffect, useState } from "react";
import "../css/Featured.css";
import { useParams } from "react-router-dom";
import axiosInstance from "../api/axiosConfig";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import AddToCartButton from "../components/AddToCartButton";

export default function Categories() {
  const [categoryName, setCategoryName] = useState("");
  const [products, setProducts] = useState([]);
  const params = useParams();

  const getCategory = async () => {
    try {
      const categoryResponse = await axiosInstance.get(`/categories/${params.slug}`);
      const productsResponse = await axiosInstance.get(`/products?category=${params.slug}`);
      setProducts(productsResponse.data);
      setCategoryName(categoryResponse.data.name);
    } catch (err) {
      console.log(err.response.data.msg);
    }
  };

  useEffect(() => getCategory(), [params]);

  return (
    <div>
      <Navbar />
      <section className="veg_section layout_padding">
        <div className="container">
          <div className="heading_container heading_center">
            <h2>{categoryName}</h2>
          </div>
          <div className="row">
            {products.map((product) => {
              return (
                <div
                  key={product.id}
                  className="col-md-6 col-lg-4 d-flex flex-column align-items-center"
                >
                  <div className="box">
                    <div className="img-box">
                      <img
                        src={process.env.REACT_APP_IMG_BASE_URL + product.image}
                        alt={product.name}
                      />
                    </div>
                    <div className="detail-box">
                      <Link to={`/product/${product.slug}`} className="">
                        {product.name}
                      </Link>
                      <div className="price_box">
                        <h6 className="price_heading">
                          <span>U$S</span> {product.price}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <AddToCartButton
                    product={product}
                    quantityToAdd={1}
                    hasFormBeenSubmitted={false}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
